import React from "react";
import {useFormik} from "formik";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {DateTimePicker} from "@mui/x-date-pickers";
import LoadingButton from "@mui/lab/LoadingButton";


const DateTimeAttributeForm = (props) => {
    const {attribute, label, value, validationSchema, onClose, onSubmit, isLoading} = props

    const formik = useFormik({
        initialValues: {[attribute]: value},
        validationSchema: validationSchema,
        validateOnMount: true,
        onSubmit: (values) => {
            // Cut out the time zone. This way the time send to the server is considered as local time.
            const data = {[attribute]: values[attribute]}
            onSubmit(data)
        },
    });

    return <Dialog onClose={onClose} open={true} fullWidth>
        <DialogTitle>Aggiorna {label.toLowerCase()}</DialogTitle>
        <DialogContent>
            <DateTimePicker
                label={label}
                value={formik.values[attribute]}
                name={attribute}
                onChange={(value) => formik.setFieldValue(attribute, value)}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        error: Boolean(formik.touched[attribute]) && Boolean(formik.errors[attribute]),
                        helperText: formik.touched[attribute] && formik.errors[attribute],
                        sx: {mt: 1}
                    }
                }}
            />
        </DialogContent>
        <DialogActions sx={{py: 2, px: 3}}>
            <Button color={"primary"}
                    variant={"text"}
                    onClick={onClose}>
                Cancella
            </Button>
            <LoadingButton onClick={() => formik.handleSubmit()}
                           loading={!!isLoading}
                           variant="contained">
                Salva
            </LoadingButton>
        </DialogActions>
    </Dialog>
}

DateTimeAttributeForm.propTypes = {
    attribute: PropTypes.string.isRequired,  // Name of the attribute (it will be passed in an object when submit is called)
    label: PropTypes.string.isRequired,  // Label of the attribute shown
    value: PropTypes.any,  // Initial value of the attribute
    defaultValue: PropTypes.object,  // Default value of the value
    validationSchema: PropTypes.object,  // Validation schema for the attribute
    onClose: PropTypes.func.isRequired,  // Function called when closing the form
    onSubmit: PropTypes.func.isRequired,  // Function called when submitting the form
    isLoading: PropTypes.bool,
};

export default DateTimeAttributeForm;